import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../../../../../store/config';
import { commonService } from '../../../../../store/services/ServiceCommon';
import { routes } from '../../../../../store/routes';
import { Icon } from "semantic-ui-react";
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import Loading from '../../../../../components/others/Loading';
import AnalyticsInsights from './AnalyticsInsights';

const C = {
    pink: "#d60c8c",
    pinkSoft: "rgba(214, 12, 140, 0.1)",
    blue: "#2185d0",
    purple: "#6435c9",
    green: "#21ba45",
    orange: "#f2711c",
};

const shell = {
    borderRadius: "10px",
    border: "1px solid #eee",
    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    background: "#fff",
    overflow: "hidden",
};

const doughnutOpts = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: "bottom", labels: { boxWidth: 10, padding: 8, font: { size: 11 } } } },
    cutout: "65%",
};

function StatTile({ icon, color, label, value, link }) {
    return (
        <div style={{
            flex: "1 1 160px",
            background: "var(--white)",
            borderRadius: "8px",
            border: "1px solid #eee",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            padding: "1.2rem 1.4rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            borderLeft: `4px solid ${color}`,
        }}>
            <div style={{ textAlign: "left", minWidth: 0 }}>
                <div style={{ fontSize: "1.9rem", fontWeight: "bold", lineHeight: 1, color: "#222" }}>{value ?? "—"}</div>
                <div style={{ color: "#888", fontSize: "0.95rem", marginTop: "0.3rem" }}>{label}</div>
                {link && (
                    <Link to={link} style={{ display: "inline-block", color: C.pink, fontWeight: "bold", fontSize: "0.82rem", marginTop: "0.45rem" }}>
                        zoznam <Icon name="angle right" style={{ margin: 0 }} />
                    </Link>
                )}
            </div>
            <Icon name={icon} size="big" style={{ color, margin: 0, flexShrink: 0 }} />
        </div>
    );
}

function ChartBlock({ title, total, data, colors }) {
    return (
        <div style={{ padding: "1rem 1.15rem" }}>
            <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>{title}</div>
            <div style={{ fontSize: "1.4rem", fontWeight: "bold", color: "#222" }}>{total}</div>
            <div style={{ height: "160px", marginTop: "0.35rem" }}>
                <Doughnut
                    data={{
                        labels: data.map((d) => d.label),
                        datasets: [{ data: data.map((d) => d.value), backgroundColor: colors, borderWidth: 0 }],
                    }}
                    options={doughnutOpts}
                />
            </div>
        </div>
    );
}

const HomeScreenStats = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [stats, setStats] = useState({});

    useEffect(() => {
        async function fetchStats() {
            setIsLoading(true);
            const request = await commonService.getStats(API.GET_STATS + "totals/");
            if (request.status === 200) {
                setStats(request.response);
            }
            setIsLoading(false);
        }
        fetchStats();
    }, []);

    const totalPayments = (stats.total_paid_invoices || 0) + (stats.total_non_paid_invoices || 0);

    return (
        <div>
            <AnalyticsInsights />

            <div style={shell}>
                <div style={{
                    padding: "0.9rem 1.25rem",
                    borderBottom: "1px solid #f0f1f3",
                    fontWeight: "bold",
                    fontSize: "1.05rem",
                    color: "#222",
                }}>
                    Prehľad systému
                </div>

                {isLoading ? (
                    <div style={{ padding: "2rem" }}><Loading /></div>
                ) : (
                    <>
                        <div style={{
                            padding: "1rem 1.25rem",
                            display: "flex",
                            gap: "1rem",
                            flexWrap: "wrap",
                            borderBottom: "1px solid #f0f1f3",
                        }}>
                            <StatTile icon="building" color={C.pink} label="Zadávatelia" value={stats.total_providers} link={routes.STATS_PROVIDERS} />
                            <StatTile icon="user md" color={C.blue} label="Kouči" value={stats.total_coaches} link={routes.STATS_COACHES} />
                            <StatTile icon="map marker alternate" color={C.purple} label="Mestá a obce" value={stats.total_towns} link={routes.STATS_TOWNS} />
                            <StatTile icon="users" color={C.green} label="Užívatelia" value={stats.total_clients} />
                            <StatTile icon="calendar check outline" color={C.orange} label="Aktivity" value={stats.total_activities} link={routes.STATS_ACTIVITIES} />
                        </div>

                        <div className="admin-system-bottom" style={{
                            display: "grid",
                            gridTemplateColumns: "1.4fr 1fr 1fr",
                        }}>
                            <div style={{
                                padding: "1.15rem 1.25rem",
                                borderRight: "1px solid #f0f1f3",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.65rem", marginBottom: "0.35rem" }}>
                                    <Icon name="credit card" style={{ margin: 0, color: C.pink }} />
                                    <span style={{ fontSize: "0.82rem", color: "#6b7280" }}>Platby celkom</span>
                                </div>
                                <div style={{ fontSize: "2rem", fontWeight: "bold", color: "#222", lineHeight: 1 }}>
                                    {totalPayments}
                                </div>
                                <div style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "0.35rem" }}>
                                    <span style={{ color: C.green, fontWeight: "bold" }}>{stats.total_paid_invoices}</span> zaplatených
                                    <span style={{ margin: "0 0.4rem", color: "#ddd" }}>|</span>
                                    <span style={{ color: "#999" }}>{stats.total_non_paid_invoices} nezaplatených</span>
                                </div>
                                <Link to={routes.STATS_PAYMENTS} style={{ color: C.pink, fontWeight: "bold", fontSize: "0.82rem", marginTop: "0.65rem" }}>
                                    Zobraziť platby <Icon name="angle right" style={{ margin: 0 }} />
                                </Link>
                            </div>

                            <ChartBlock
                                title="Registrácie"
                                total={stats.total_registrations}
                                data={[
                                    { label: `Aktívni (${stats.total_active_users})`, value: stats.total_active_users },
                                    { label: `Neaktívni (${stats.total_inactive_users})`, value: stats.total_inactive_users },
                                ]}
                                colors={["#6fcf97", "#d1d5db"]}
                            />

                            <ChartBlock
                                title="Termíny"
                                total={stats.total_events}
                                data={[
                                    { label: `Publikované (${stats.total_published_events})`, value: stats.total_published_events },
                                    { label: `Zrušené (${stats.total_canceled_events})`, value: stats.total_canceled_events },
                                ]}
                                colors={[C.orange, "#c8e6c9"]}
                            />
                        </div>
                    </>
                )}
            </div>

            <style>{`
                @media (max-width: 900px) {
                    .admin-system-bottom { grid-template-columns: 1fr !important; }
                    .admin-system-bottom > div { border-right: none !important; border-bottom: 1px solid #f0f1f3; }
                }
            `}</style>
        </div>
    );
};

export default HomeScreenStats;
